import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
  FaHome,
  FaPen,
  FaClipboardCheck,
  FaBookmark,
  FaTags,
  FaCalendarCheck,
  FaDollarSign
} from 'react-icons/fa';

import logo from '../assets/logo1.png'; // The Pride logo

const Sidebar = () => {
  const [newHotelReservationsCount, setNewHotelReservationsCount] = useState(0);
  const location = useLocation();

  const checkForNewReservations = async () => {
    try {
      // Fetch only hotel bookings (The Pride)
      const hotelResponse = await axios.get('https://admin.thepridehotel.in/api/hotel_bookings');
      const newHotel = hotelResponse.data.filter(res => res.status === 'New').length;
      setNewHotelReservationsCount(newHotel);
    } catch (error) {
      console.error('Error fetching new reservation counts:', error);
      setNewHotelReservationsCount(0);
    }
  };

  useEffect(() => {
    checkForNewReservations();
    const intervalId = setInterval(checkForNewReservations, 5000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    // Only reset the hotel count when visiting the hotel reservations page
    if (location.pathname === '/ThePrideReservations') {
      setNewHotelReservationsCount(0);
    }
  }, [location.pathname]);

  const prideMenu = [
    { icon: <FaHome />, label: 'Dashboard', path: '/dashboard' },
    { icon: <FaCalendarCheck />, label: 'Reservations', path: '/ThePrideReservations', isReservationsPage: true },
    { icon: <FaPen />, label: 'Front desk', path: '/front-desk' },
    { icon: <FaClipboardCheck />, label: 'Guest', path: '/guest' },
    { icon: <FaBookmark />, label: 'Rooms', path: '/rooms' },
    { icon: <FaTags />, label: 'Deal', path: '/deal' },
    { icon: <FaDollarSign />, label: 'Rate', path: '/rate' },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');

        .sidebar {
          width: 260px;
          background: #ffffff;
          height: 100vh;
          font-family: 'Open Sans', sans-serif;
          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          padding-bottom: 40px;
        }

        .logo-container {
          text-align: center;
          margin-bottom: 24px;
          padding-top: 16px;
        }

        .logo-container img {
          width: 100px;
          height: auto;
        }

        .nav-link {
          display: flex;
          align-items: center;
          padding: 14px 24px;
          text-decoration: none;
          color: #4b5563;
          border-radius: 14px;
          margin: 6px 16px;
          font-size: 15px;
          transition: all 0.2s ease;
          position: relative;
        }

        .nav-link:hover,
        .nav-link.active {
          background-color: #f5f3f0;
          color: #AE7D54;
          font-weight: 600;
        }

        .nav-link .icon {
          font-size: 16px;
          margin-right: 14px;
          transition: color 0.2s ease;
        }

        .nav-link:hover .icon,
        .nav-link.active .icon {
          color: #AE7D54;
        }

        .new-reservations-count {
          background-color: #EF4444;
          color: #FFFFFF;
          font-size: 10px;
          font-weight: 700;
          padding: 4px 8px;
          border-radius: 10px;
          margin-left: auto;
          min-width: 20px;
          text-align: center;
          line-height: 1;
        }
      `}</style>

      <div className="sidebar">
        <div className="logo-container">
          <img src={logo} alt="The Pride Logo" />
        </div>
        {prideMenu.map(({ icon, label, path, isReservationsPage }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
          >
            <span className="icon">{icon}</span>
            <span>{label}</span>
            {isReservationsPage && newHotelReservationsCount > 0 && (
              <span className="new-reservations-count">{newHotelReservationsCount}</span>
            )}
          </NavLink>
        ))}
      </div>
    </>
  );
};

export default Sidebar;